export default {
    auth: {
        login: {
            title: 'Teacher Login',
            buttons: {
                enter: 'Log In',
                chathess: 'Chathess Login',
                register: 'Sign Up',
            },
        },
    },
    register: {
        title: 'Sign Up',
        description: 'Please enter the information required to sign up',
        chathessId: 'Chathess ID',
        accountInfo: 'Account Information',
        accessId: 'Username',
        password: 'Password',
        passwordConfirm: 'Confirm Password',
        buttons: {
            cancel: 'Cancel',
            register: 'Sign Up',
        },
    },
    home: {
        title: 'Tap an Activity to start learning.',
    },
    self: {
        title: 'Self-study Mode Status',
        clear: 'All Done!',
        tabs: {
            all: 'View All',
            completed: 'Completed Students',
            inProgress: 'In-progress Students',
        },
        noStudent: ({ values }: { values: { tab: string } }) => {
            const { tab } = values;

            if (tab === 'completed') {
                return 'No Students have completed.';
            } else if (tab === 'in_progress') {
                return 'No Students in progress.';
            } else {
                return 'No Students found.';
            }
        },
        table: {
            name: 'Name',
            progress: 'Progress',
            module: 'Module',
            time: 'Time Spent',
        },
    },
};
